export default [
  'applySection',
  'articleSection',
  'blogPage',
  'blogSliderSection',
  'blogTag',
  'button',
  'calendarEvent',
  'card',
  'cardsSection',
  'categoryCircle',
  'categoryCirclesSection',
  'contact',
  'contactCardsSection',
  'contactSection',
  'expandableCategory',
  'expandableCategorySection',
  'expandableFeatureItem',
  'expandableFeaturesSection',
  'faq',
  'faqTab',
  'faqSection',
  'feature',
  'featureSection',
  'fullVideoSection',
  'generalPage',
  'headers',
  'headersGeneralPage',
  'howWeWorkProductSection',
  'image',
  'imageGrid',
  'imageListItem',
  'imageListItemSection',
  'imagePairSection',
  'introSection',
  'introCarouselSection',
  'introVideoSection',
  'investorsItem',
  'investorsLandingTabs',
  'investorsLandingTab',
  'investorsLandingSection',
  'investorsSection',
  'investorsTab',
  'job',
  'journeysSection',
  'locationTag',
  'logo',
  'mapContact',
  'media',
  'mediaCarousel',
  'mediaKitItem',
  'newsPage',
  'newsSliderSection',
  'newsTag',
  'oldNews',
  'page',
  'person',
  'personDescription',
  'productCard',
  'productRangeSection',
  'productRangeItem',
  'productSliderSection',
  'productThumbnail',
  'productThumbnailsSection',
  'recruitmentSection',
  'recruitmentStep',
  'reportItem',
  'reportsSection',
  'requirementsSection',
  'safetyToolkitItem',
  'safetyToolkitCategory',
  'safetyToolkitSubcategory',
  'scrollButton',
  'searchSection',
  'slideShow',
  'socialMediaFooter',
  'socialMediaItem',
  'subtitleHeaders',
  'tableHtml',
  'tableCell',
  'tableContentRow',
  'tableSection',
  'tableTitleRow',
  'testimonialItem',
  'testimonialsSection',
  'text',
  'textLinkSection',
  'twitterSection',
  'verticalFeatureSection',
  'verticalFeatureItem',
  'video',
  'videoButton',
  'videoSection',
  'whitePaper',
  'whitePaperSliderSection',
  'whyDevelopSection',
  'whyJoinSection',
  'youtubeVideo',
  'audio/mpeg',
  'image/jpeg',
  'image/png',
  'video/mp4',
  'image/svg+xml',
  'video/webm',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];



// WEBPACK FOOTER //
// ./src/store/contentTypeIds.js